import { pluralizeWithCount } from '@shared/strings/utils';

import { ModalShell } from '@/components/modals/modal-shell';

export interface JobsDlqErrorPayload {
  action: 'redrive' | 'discard';
  dlqUrl: string;
  messageIds: string[];
  message: string;
}

export const JobsDlqErrorModal = ({ payload, onClose }: { payload: JobsDlqErrorPayload; onClose: () => void }) => {
  const actionLabel = payload.action === 'redrive' ? 'Redrive' : 'Discard';

  return (
    <ModalShell title={`${actionLabel} failed`} onClose={onClose}>
      <p>{payload.message}</p>
      <p className='mt-3 text-xs text-neutral-500'>
        {pluralizeWithCount(payload.messageIds.length, 'message')} selected — none were processed.
      </p>
      <p className='mt-1 break-all text-xs text-neutral-400'>
        DLQ: <code className='font-mono'>{payload.dlqUrl}</code>
      </p>
    </ModalShell>
  );
};
